import React from 'react';
import { connect } from 'react-redux';
import { GLNumberActions } from '../_actions';
import { NewGLNumberModal, DeleteGLNumberModal } from "../GLNumbers"
import { Form, Row, Col } from 'reactstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

function deleteLinkFormatter(value, row, index, field) {
  return (
    <DeleteGLNumberModal className="full-width" color="danger" gl_number_id={row.value}></DeleteGLNumberModal>
  );
}

function selectDataFormatterLabel(cell, row) {
  return <span>{row.label}</span>
}

const columns = [{
  dataField: 'label',
  text: 'Numéro GL',
  editable: true
},{
  dataField: 'delete',
  text: 'Supprimer',
  editable: false,
  formatter: deleteLinkFormatter
}];

const remote={
  filter: false,
  pagination: false,
  sort: false,
  cellEdit: true
}

class AllGLNumbers extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        gl_numbers: []
      };
    }

  componentDidMount() {
    this.props.getAllGLNumbers();
  }

  onTableChange(type, newState) {
    if(type==="cellEdit")
    {
      this.props.handleChange(newState.cellEdit);
    }
    return true;
  }

  render() {
    return (
      <div style={{marginLeft:"5%", marginRight:"5%"}}>
        <Row>
          <Col md="3" xs="6" style={{marginBottom: "10px"}}><NewGLNumberModal buttonLabel="Nouveau numéro GL" /></Col><Col md="1" xs="6"></Col>
        </Row>
        <br/>
        { this.props.gl_numbers && this.props.gl_numbers.items && this.props.gl_numbers.items.length > 0 &&
          <div className="table-responsive-sm">
            <BootstrapTable style={{ margin:"auto"}} bootstrap4={true} bordered={false} keyField='value' remote={remote} cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) } onTableChange={this.onTableChange.bind(this)} data={ this.props.gl_numbers.items } columns={ columns } />
          </div>
        }
      </div>
    )

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (edit) => {
      dispatch(GLNumberActions.update(edit));
    },
    getAllGLNumbers: () => {
      dispatch(GLNumberActions.getAll());
    }
  }
}

function mapStateToProps(state){
    return {
        gl_numbers: state.gl_numbers
    }
}

const connectedAllGLNumbers = connect(mapStateToProps, mapDispatchToProps)(AllGLNumbers);
export { connectedAllGLNumbers as AllGLNumbers };
